import styled, { css } from 'styled-components';
import { themeGet } from '../../foundation/theme/themeGet/get.js';
import { pxToRem } from '../../foundation/spacing/utils.js';
import { Typography } from '../../foundation/Typography/styled.js';

var sizeToIconSize = {
  '2xl': 56,
  xl: 48,
  lg: 40,
  md: 32,
  sm: 24,
  xs: 24,
  xxs: 24
};
var sizeToLabelGap = {
  '2xl': 4,
  xl: 4,
  lg: 2,
  md: 2,
  sm: 2,
  xs: 2,
  xxs: 2
};
var sizeToContainerGap = {
  '2xl': 'spacing.lg',
  xl: 'spacing.lg',
  lg: 'spacing.lg',
  md: 'spacing.lg',
  sm: 'spacing.md',
  xs: 'spacing.md',
  xxs: 'spacing.md'
};
function titlesOnSameLine(props) {
  if (props.$alignment !== 'horizontal') {
    return false;
  }
  if (props.$size === 'sm' || props.$size === 'xs' || props.$size === 'xxs') {
    return true;
  }
  return false;
}
var Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-182m6td-0"
})(["display:flex;align-items:", ";gap:", ";flex-direction:", ";text-align:", ";overflow:hidden;"], function (_ref) {
  var $alignment = _ref.$alignment;
  return $alignment === 'vertical-left' ? 'flex-start' : 'center';
}, function (_ref2) {
  var $alignment = _ref2.$alignment,
    $size = _ref2.$size;
  return $alignment === 'horizontal' ? themeGet('spacing.md') : themeGet(sizeToContainerGap[$size]);
}, function (_ref3) {
  var $alignment = _ref3.$alignment;
  return $alignment === 'horizontal' ? 'row' : 'column';
}, function (_ref4) {
  var $alignment = _ref4.$alignment;
  return $alignment === 'vertical' ? 'center' : 'start';
});
var LabelContainer = styled.div.withConfig({
  displayName: "LabelContainer",
  componentId: "sc-182m6td-1"
})(["display:flex;flex-direction:", ";align-items:", ";gap:", ";min-width:0;"], function (props) {
  return titlesOnSameLine(props) ? 'row' : 'column';
}, function (props) {
  return titlesOnSameLine(props) && 'baseline';
}, function (_ref5) {
  var $size = _ref5.$size;
  return $size && pxToRem(sizeToLabelGap[$size]);
});
var StyledTypography = styled(Typography).withConfig({
  displayName: "StyledTypography",
  componentId: "sc-182m6td-2"
})(["", ""], function (props) {
  return props.$truncate && css(["white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"]);
});
var IconContainer = styled.div.withConfig({
  displayName: "IconContainer",
  componentId: "sc-182m6td-3"
})(["[data-icon='falcon'],svg{display:block;width:", ";height:", ";}[data-icon='falcon']{color:", ";}"], function (props) {
  return pxToRem(sizeToIconSize[props.$size]);
}, function (props) {
  return pxToRem(sizeToIconSize[props.$size]);
}, themeGet('colors.gray.800'));

export { Container, IconContainer, LabelContainer, StyledTypography };
